<template>
  <expandable-material-card
    :title="$t('components.portal.admin_email_recipients')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="contacts"
  >
    <v-card-text>
      <admin-email-recipients-table
        v-for="lang in Object.keys(providers)"
        :key="lang"
        :provider="providers[lang]"
        :lang="lang"
        @update="update($event, lang)"
        :items="providers[lang].items"
      />
    </v-card-text>
  </expandable-material-card>
</template>

<script>
import { mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import AdminEmailRecipientsHeaders from "@/headers/AdminEmailRecipients";
import AdminEmailRecipientsTable from "./AdminEmailRecipientsTable.vue";
import ExpandableMaterialCard from './ExpandableMaterialCard.vue';

export default {
  components: {
    AdminEmailRecipientsTable,
    ExpandableMaterialCard
  },
  props: ["items"],
  data() {
    return {
      providers: {},
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    items: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    this.loadPlanData();
  },
  methods: {
    update(items, lang) {
      let val = JSON.parse(JSON.stringify(this.items));
      val[this.$helpers.toPascalCase(lang)] = items.map((o) => o.Email);
      this.$nextTick(() => {
        this.$emit("update", val);
      });
    },
    loadPlanData() {
      for (let i = 0; i < this.languages.length; i++) {
        let items = [];
        if (this.items !== null && this.items !== undefined) {
          // if (!this.items.Fr) {
          //   this.items.Fr = ["eldarha@gmail.com", "v.antoniou@dotbydot.gr"];
          // }
          // console.log(this.items);
          items = this.items[
            this.$helpers.toPascalCase(this.languages[i].language)
          ].map((o) => {
            return {
              Identifier: Math.random().toString(),
              Email: o,
            };
          });
        }
        // console.log(items);
        this.providers[
          this.$helpers.toPascalCase(this.languages[i].language)
        ] = new InMemoryProvider(items, AdminEmailRecipientsHeaders);
      }
      // console.log(Object.keys(this.providers));
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
  },
};
</script>
